import { deleteApi, getApi, postApi, putApi } from "../Services/Interceptor";

const AUTH_LOGIN_API = "admin/login";

const CLUB_LISTING_API = "admin/clubListing";

const GET_SEARCH_CLUB_LISTING = "admin/searchClub";

const UPDATE_CLUB_DISCOUNT = "admin/updateDiscount";

const CREATE_USER = "create-user";

const LOGIN_USER = "login";

const ALL_USER_LIST = "all-users";

const DELETE_USER = "delete-user";

export const adminLogin = (payload) => {
  return postApi(AUTH_LOGIN_API, payload);
};

export const getClubListing = (val) => {
  return getApi(
    `${CLUB_LISTING_API}?pageNumber=${val.pageNumber}&limit=${val.limit}`
  );
};

export const getSearchClubListing = (word) => {
  return getApi(`${GET_SEARCH_CLUB_LISTING}?search=${word}`);
};

export const updateClubDiscount = (payload) => {
  return putApi(UPDATE_CLUB_DISCOUNT, payload);
};

export const createUser = (payload) => postApi(CREATE_USER, payload);

export const loginUser = (payload) => postApi(LOGIN_USER, payload);

export const getAllUsersList = (params) => getApi(`${ALL_USER_LIST}?${params}`);

export const deleteUser = (params) => deleteApi(`${DELETE_USER}?${params}`);
